import {BuyTicketFlowContext} from './type';

export const SESSION_STORAGE_ATTEMPT_TO_BUY_TICKET_INFO =
  'attemp_to_buy_ticket_info';

/**
 * 뷰어 진입 시 해당 키가 있다면 ready_to_use 없이 바로 티켓을 사용합니다
 */
export const QUERY_KEY_VIEWER_TICKET_TYPE_TO_USE = 'ticketTypeToUse';

export const SESSION_STORAGE_TICKET_INFO = 'ticket_info';
export const SESSION_STORAGE_READY_TO_USE_TICKET_QUERY_VARIABLES =
  'ready_to_use_ticket_query_variables';

export const LOCAL_STORAGE_BUY_TICKET_FLOW_DEBUG = 'buyTicketFlowDebug';

export const TICKET_STATE_NAME = 'ticket';

export const initialContext: BuyTicketFlowContext = {
  flowType: undefined,
  isMobile: undefined,
  user: undefined,
  ticketProcessParam: undefined,
  buySetProcessParam: undefined,
  queryClient: undefined,
  simpleSeriesSingleInfo: undefined,
  readyToUseTicket: undefined,
  setBuyTicketInfo: undefined,
  setReadyToUseTicket: undefined,
  setBuyResult: undefined,
  error: undefined,
  expiredConfirmed: undefined,
  dispatch: undefined,
  storedTicketInfo: undefined,
  currentProductId: undefined,
  selectedNonstopWatchingBuyTicketInfo: undefined,
  useTicketType: undefined,
  buyAndUseTicketInfo: undefined,
  loginPopupConfirm: undefined,
  needProgressDelay: false,
  isShortsDrama: undefined,
};
